export const DEDUCTION_FORM_LINES = {
    ADVERTISING: {
        label: 'Advertising & Marketing',
        schedule_c: '8',
        schedule_c_label: 'Advertising',
        form_1120: '22',
        form_1120_label: 'Advertising',
    },
    VEHICLE: {
        label: 'Vehicle Expenses',
        schedule_c: '9',
        schedule_c_label: 'Car and truck expenses',
        form_1120: 'OTHER',
        form_1120_label: 'Vehicle expenses',
    },
    COMMISSIONS: {
        label: 'Commissions & Fees',
        schedule_c: '10',
        schedule_c_label: 'Commissions and fees',
        form_1120: 'OTHER',
        form_1120_label: 'Commissions and fees',
    },
    CONTRACT_LABOR: {
        label: 'Contract Labor',
        schedule_c: '11',
        schedule_c_label: 'Contract labor',
        form_1120: '13',
        form_1120_label: 'Salaries and wages (less employment credits)',
    },
    DEPRECIATION: {
        label: 'Depreciation',
        schedule_c: '13',
        schedule_c_label: 'Depreciation and section 179 expense',
        form_1120: '20',
        form_1120_label: 'Depreciation (attach Form 4562)',
    },
    EMPLOYEE_BENEFITS: {
        label: 'Employee Benefits',
        schedule_c: '14',
        schedule_c_label: 'Employee benefit programs',
        form_1120: '24',
        form_1120_label: 'Employee benefit programs',
    },
    INSURANCE: {
        label: 'Insurance',
        schedule_c: '15',
        schedule_c_label: 'Insurance (other than health)',
        form_1120: 'OTHER',
        form_1120_label: 'Insurance (other than employee benefits)',
    },
    MORTGAGE_INTEREST: {
        label: 'Mortgage Interest',
        schedule_c: '16a',
        schedule_c_label: 'Interest: Mortgage (paid to banks, etc.)',
        form_1120: '18',
        form_1120_label: 'Interest',
    },
    OTHER_INTEREST: {
        label: 'Other Interest',
        schedule_c: '16b',
        schedule_c_label: 'Interest: Other',
        form_1120: '18',
        form_1120_label: 'Interest',
    },
    LEGAL_PROFESSIONAL: {
        label: 'Legal & Professional',
        schedule_c: '17',
        schedule_c_label: 'Legal and professional services',
        form_1120: 'OTHER',
        form_1120_label: 'Legal and professional services',
    },
    OFFICE: {
        label: 'Office Expenses',
        schedule_c: '18',
        schedule_c_label: 'Office expense',
        form_1120: 'OTHER',
        form_1120_label: 'Office expense',
    },
    PENSION: {
        label: 'Pension & Retirement',
        schedule_c: '19',
        schedule_c_label: 'Pension and profit-sharing plans',
        form_1120: '23',
        form_1120_label: 'Pension, profit-sharing, etc., plans',
    },
    RENT_EQUIPMENT: {
        label: 'Equipment Rent / Lease',
        schedule_c: '20a',
        schedule_c_label: 'Rent or lease: Vehicles, machinery, equipment',
        form_1120: '16',
        form_1120_label: 'Rents',
    },
    RENT_PROPERTY: {
        label: 'Property Rent / Lease',
        schedule_c: '20b',
        schedule_c_label: 'Rent or lease: Other business property',
        form_1120: '16',
        form_1120_label: 'Rents',
    },
    REPAIRS: {
        label: 'Repairs & Maintenance',
        schedule_c: '21',
        schedule_c_label: 'Repairs and maintenance',
        form_1120: '14',
        form_1120_label: 'Repairs and maintenance',
    },
    SUPPLIES: {
        label: 'Supplies',
        schedule_c: '22',
        schedule_c_label: 'Supplies',
        form_1120: 'OTHER',
        form_1120_label: 'Supplies',
    },
    TAXES_LICENSES: {
        label: 'Taxes & Licenses',
        schedule_c: '23',
        schedule_c_label: 'Taxes and licenses',
        form_1120: '17',
        form_1120_label: 'Taxes and licenses',
    },
    TRAVEL: {
        label: 'Travel',
        schedule_c: '24a',
        schedule_c_label: 'Travel',
        form_1120: 'OTHER',
        form_1120_label: 'Travel',
    },
    MEALS: {
        label: 'Meals (50% deductible)',
        schedule_c: '24b',
        schedule_c_label: 'Deductible meals',
        form_1120: 'OTHER',
        form_1120_label: 'Meals (50% deductible)',
        is_meals_50pct: true,
    },
    UTILITIES: {
        label: 'Utilities',
        schedule_c: '25',
        schedule_c_label: 'Utilities',
        form_1120: 'OTHER',
        form_1120_label: 'Utilities',
    },
    COMMUNICATION: {
        // IRS rolls phone/internet under Utilities; we keep them separate for UX
        // and combine at form-render time. See sp_tax_get_schedule_c / 1120.
        label: 'Communication (Phone, Internet)',
        schedule_c: '25',
        schedule_c_label: 'Utilities',
        form_1120: 'OTHER',
        form_1120_label: 'Communication (phone, internet)',
    },
    WAGES: {
        label: 'Wages',
        schedule_c: '26',
        schedule_c_label: 'Wages (less employment credits)',
        form_1120: '13',
        form_1120_label: 'Salaries and wages (less employment credits)',
    },
    OFFICER_COMP: {
        // C-Corp / S-Corp only. On Schedule C, sole props pay themselves via
        // owner draws (not deductible) — there is no equivalent line.
        label: 'Officer Compensation',
        schedule_c: null,
        schedule_c_label: null,
        form_1120: '12',
        form_1120_label: 'Compensation of officers',
    },
    BAD_DEBTS: {
        // On Schedule C, bad debts are deductible only if the income was
        // previously reported (cash-basis sole props rarely use this).
        label: 'Bad Debts',
        schedule_c: '9',
        schedule_c_label: 'Bad debts from sales or services',
        form_1120: '15',
        form_1120_label: 'Bad debts',
    },
    CHARITABLE: {
        // Sole props deduct on personal Schedule A, NOT Schedule C. We surface
        // a warning in the Schedule C generator when a charitable expense is
        // assigned to a sole-prop profile.
        label: 'Charitable Contributions',
        schedule_c: null,
        schedule_c_label: null,
        form_1120: '19',
        form_1120_label: 'Charitable contributions (≤10% taxable income)',
    },
    BANK_FEES: {
        label: 'Bank & Card Fees',
        schedule_c: '27a',
        schedule_c_label: 'Other expenses (Part V): Bank fees',
        form_1120: 'OTHER',
        form_1120_label: 'Bank and card fees',
    },
    SHIPPING: {
        label: 'Shipping & Postage',
        schedule_c: '27a',
        schedule_c_label: 'Other expenses (Part V): Shipping & postage',
        form_1120: 'OTHER',
        form_1120_label: 'Shipping and postage',
    },
    EDUCATION: {
        label: 'Education & Training',
        schedule_c: '27a',
        schedule_c_label: 'Other expenses (Part V): Education & training',
        form_1120: 'OTHER',
        form_1120_label: 'Education and training',
    },
    SUBSCRIPTIONS: {
        label: 'Subscriptions',
        schedule_c: '18',
        schedule_c_label: 'Office expense (subscriptions)',
        form_1120: 'OTHER',
        form_1120_label: 'Subscriptions and software',
    },
    OTHER: {
        label: 'Other',
        schedule_c: '27a',
        schedule_c_label: 'Other expenses (Part V)',
        form_1120: 'OTHER',
        form_1120_label: 'Miscellaneous',
    },
};
/**
 * Entity types that file Schedule C (1040). Both sole proprietorships and
 * single-member LLCs are disregarded entities for federal tax purposes.
 */
export const SCHEDULE_C_ENTITY_TYPES = ['sole_proprietorship', 'llc_single'];
/**
 * Entity types that file Form 1120.
 */
export const FORM_1120_ENTITY_TYPES = ['c_corp'];
/**
 * Resolve which IRS form a business profile should generate, given its tax
 * year's entity type. Returns 'unsupported' for partnerships, S-Corps, and
 * multi-member LLCs (those file 1065/1120-S — not yet implemented).
 */
export function getTaxFormForEntity(entityType) {
    if (!entityType)
        return 'unsupported';
    if (SCHEDULE_C_ENTITY_TYPES.includes(entityType))
        return 'schedule_c';
    if (FORM_1120_ENTITY_TYPES.includes(entityType))
        return 'form_1120';
    return 'unsupported';
}
//# sourceMappingURL=deduction-form-lines.js.map